
const AMZ_DATE = "X-Amz-Date";
const AMZ_EXPIRES = "X-Amz-Expires";

function getAwsPresignedExpiryMs(urlString: string): number | null {
  try {
    const url = new URL(urlString);
    const dateStr = url.searchParams.get(AMZ_DATE);
    const expiresStr = url.searchParams.get(AMZ_EXPIRES);
    if (!dateStr || !expiresStr || !/^\d{8}T\d{6}Z$/.test(dateStr)) return null;
    const y = Number(dateStr.slice(0, 4));
    const mo = Number(dateStr.slice(4, 6));
    const d = Number(dateStr.slice(6, 8));
    const h = Number(dateStr.slice(9, 11));
    const mi = Number(dateStr.slice(11, 13));
    const s = Number(dateStr.slice(13, 15));
    const startMs = Date.UTC(y, mo - 1, d, h, mi, s);
    const secs = Number(expiresStr);
    if (!Number.isFinite(startMs) || !Number.isFinite(secs)) return null;
    return startMs + secs * 1000;
  } catch {
    return null;
  }
}

export async function downloadRemoteAttachment(
  url: string,
  filename: string,
): Promise<void> {
  const expiryMs = getAwsPresignedExpiryMs(url);
  if (expiryMs !== null && Date.now() > expiryMs) {
    window.open(url, "_blank", "noopener,noreferrer");
    return;
  }

  try {
    const response = await fetch(url, {
      method: "GET",
      mode: "cors",
      cache: "no-store",
    });
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const blob = await response.blob();
    const objectUrl = URL.createObjectURL(blob);
    const anchor = document.createElement("a");
    anchor.style.display = "none";
    anchor.href = objectUrl;
    anchor.download = filename;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    URL.revokeObjectURL(objectUrl);
  } catch {
    window.open(url, "_blank", "noopener,noreferrer");
  }
}
